import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { EventService } from '../../services/event.service';

@Component({
  selector: 'app-roadmap',
  templateUrl: './roadmap.component.html',
  styleUrls: ['./roadmap.component.scss'],
})
export class RoadmapComponent {
   currentLanguage = '';
  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private translate: TranslateService,
    private eventService: EventService,
  ) {
    this.currentLanguage = this.translate.currentLang;
    this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      this.currentLanguage = params.lang;
    });

  }

  items = [
    {
      heading: 'roadmap.heading_one',
      content: 'roadmap.para_1',
      isOpen: true,
    },
    {
      heading: 'roadmap.heading_two',
      content: 'roadmap.para_2',
      isOpen: false,
    },
    {
      heading: 'roadmap.heading_three',
      content: 'roadmap.para_3',
      isOpen: false,
    },
  ];
   navigateToPage(section: string): void {
   this.eventService.redirectTosection(section);
  }
}
